if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (!document.querySelector('.ajax-cart-disabled')) {
        formData.append(
          'sections',
          this.cartNotification.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (document.querySelector('.ajax-cart-disabled')) {
            window.location = '/cart';
            return;
          }

          this.cartNotification.renderContents(response);
          openCartDrawer();
          initMotivatorProduct();
        })
        .catch((e) => {
          console.error('Theme add-to-cart error:', e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage =
        this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/* =========================================================
   CUSTOM BUY NOW + CONSENT MODAL FLOW
   - Opens modal
   - Requires both checkboxes
   - Adds item to cart with consent properties
   - Redirects directly to checkout
========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  console.log('[Consent Flow] DOM loaded');

  const customBuyNowButton = document.getElementById('custom-buy-now');
  const consentModal = document.getElementById('consent-modal');
  const continueButton = document.getElementById('consent-continue-button');
  const closeModalTriggers = document.querySelectorAll('[data-close-consent-modal]');
  const rateConsentCheckbox = document.getElementById('rate-consent-checkbox');
  const contactConsentCheckbox = document.getElementById('contact-consent-checkbox');
  const errorMessage = document.getElementById('consent-error-message');
  const checkinDate = document.getElementById('check_in_date');

  console.log('[Consent Flow] customBuyNowButton:', customBuyNowButton);
  console.log('[Consent Flow] consentModal:', consentModal);
  console.log('[Consent Flow] continueButton:', continueButton);
  console.log('[Consent Flow] rateConsentCheckbox:', rateConsentCheckbox);
  console.log('[Consent Flow] contactConsentCheckbox:', contactConsentCheckbox);
  console.log('[Consent Flow] errorMessage:', errorMessage);
  console.log('[Consent Flow] checkInDate:', checkinDate);

  if (
    !customBuyNowButton ||
    !consentModal ||
    !continueButton ||
    !rateConsentCheckbox ||
    !contactConsentCheckbox ||
    !errorMessage
  ) {
    console.error('[Consent Flow] One or more required elements were not found. Check IDs in main-product.liquid.');
    return;
  }

  function getProductForm() {
    const form = document.querySelector('form[action*="/cart/add"]');
    console.log('[Consent Flow] Product form:', form);
    return form;
  }

  function getSelectedVariantId() {
    const form = getProductForm();
    if (!form) return null;

    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      console.log('[Consent Flow] Variant from hidden input:', variantInput.value);
      return variantInput.value;
    }

    const variantSelect = form.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      console.log('[Consent Flow] Variant from select:', variantSelect.value);
      return variantSelect.value;
    }

    console.warn('[Consent Flow] No variant ID found');
    return null;
  }

  function getSelectedQuantity() {
    const form = getProductForm();
    if (!form) return 1;

    const quantityInput = form.querySelector('input[name="quantity"]');
    if (quantityInput && quantityInput.value) {
      const quantity = parseInt(quantityInput.value, 10);
      const finalQuantity = Number.isNaN(quantity) ? 1 : quantity;
      console.log('[Consent Flow] Quantity:', finalQuantity);
      return finalQuantity;
    }

    console.log('[Consent Flow] Default quantity = 1');
    return 1;
  }

  function updateContinueButtonState() {
  const bothChecked = rateConsentCheckbox.checked && contactConsentCheckbox.checked;

  if (bothChecked) {
    errorMessage.hidden = true;
    errorMessage.textContent = '';
    continueButton.classList.remove('consent-button-error');
  }

  console.log('[Consent Flow] Checkbox state updated:', {
    rateChecked: rateConsentCheckbox.checked,
    contactChecked: contactConsentCheckbox.checked,
    bothChecked: bothChecked
  });
}

  function openModal() {
  console.log('[Consent Flow] Opening modal');
  consentModal.hidden = false;
  document.body.style.overflow = 'hidden';

  errorMessage.hidden = true;
  errorMessage.textContent = '';
  continueButton.classList.remove('consent-button-error');
  continueButton.disabled = false;
  continueButton.textContent = 'Continue to checkout';

  updateContinueButtonState();
}

  function closeModal() {
    console.log('[Consent Flow] Closing modal');
    consentModal.hidden = true;
    document.body.style.overflow = '';
  }

  customBuyNowButton.addEventListener('click', function () {
    console.log('[Consent Flow] Custom Buy Now clicked');
    openModal();
  });

  closeModalTriggers.forEach(function (trigger, index) {
    console.log(`[Consent Flow] Close trigger bound: ${index}`);
    trigger.addEventListener('click', function () {
      closeModal();
    });
  });

  rateConsentCheckbox.addEventListener('change', updateContinueButtonState);
  contactConsentCheckbox.addEventListener('change', updateContinueButtonState);

  continueButton.addEventListener('click', async function () {
  console.log('[Consent Flow] Continue clicked');

  const missingItems = [];

  if (!rateConsentCheckbox.checked) {
    missingItems.push('Terms & Conditions / Privacy Policy');
  }

  if (!contactConsentCheckbox.checked) {
    missingItems.push('contact consent');
  }

  if (missingItems.length > 0) {
    console.warn('[Consent Flow] Missing required consent:', missingItems);

    errorMessage.textContent =
      missingItems.length === 2
        ? 'Please accept both required checkboxes before continuing.'
        : `Please accept the ${missingItems[0]} checkbox before continuing.`;

    errorMessage.hidden = false;
    continueButton.classList.add('consent-button-error');
    return;
  }

  const variantId = getSelectedVariantId();
  const quantity = getSelectedQuantity();

  if (!variantId) {
    console.error('[Consent Flow] Unable to determine selected variant');
    alert('Unable to determine the selected product variant.');
    return;
  }

  continueButton.disabled = true;
  continueButton.textContent = 'Processing...';

  const properties = {
  "_Terms Accepted": "Yes",
  "_Terms Version": window.termsVersion,
  "_Terms Page": window.termsPageUrl,
  "_Rate Details Consent": "Yes",
  "_Phone and Email Contact Consent": "Yes",
  "_Consent Timestamp": new Date().toISOString(),
  "_Consent Source": "Custom Buy Now Modal"
};

if (checkinDate?.value) {
  properties["Check In Date"] = checkinDate.value;
}

  const payload = {
    items: [
      {
        id: Number(variantId),
        quantity: quantity,
        properties
      }
    ]
  };

    console.log('[Consent Flow] Payload to /cart/add.js:', payload);

    try {
      console.log('[Consent Flow] Clearing cart before adding new item');
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!clearResponse.ok) {
        const clearError = await clearResponse.text().catch(() => '');
        console.error('[Consent Flow] Cart clear failed:', clearError);
        alert('There was an error preparing checkout. Please try again.');
        continueButton.disabled = false;
        continueButton.textContent = 'Continue to checkout';
        return;
      }

      console.log('[Consent Flow] Cart cleared successfully');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('[Consent Flow] Cart add failed:', errorData);
        alert('There was an error adding the item to cart. Please try again.');
        continueButton.disabled = false;
        continueButton.textContent = 'Continue to checkout';
        return;
      }

      const responseData = await response.json().catch(() => ({}));
      console.log('[Consent Flow] Cart add success:', responseData);

      console.log('[Consent Flow] Redirecting to /checkout');
      window.location.href = '/checkout';
    } catch (error) {
      console.error('[Consent Flow] Unexpected error:', error);
      alert('There was an unexpected error. Please try again.');
      continueButton.disabled = false;
      continueButton.textContent = 'Continue to checkout';
    }
  });
});